import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cn-edit-card-details-popup',
  templateUrl: './cn-edit-card-details-popup.component.html',
  styleUrls: ['./cn-edit-card-details-popup.component.scss']
})
export class CnEditCardDetailsPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
